// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from 'jitsi/base/environment/utils';
import { useTranslation } from 'react-i18next';
import { JitsiRecordingConstants } from 'jitsi/base/lib-jitsi-meet';
import { getConferenceName } from 'jitsi/base/conference/functions';
import RecordingLabel from 'jitsi/recording/components/web/RecordingLabel';
const useStyles = makeStyles()((theme, { isMobile }) => ({
    container: {
        zIndex: 1,
        marginTop: isMobile ? theme.spacing(4) : 20,
        position: 'absolute',
    },
    nameContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
    },
    text: {
        marginBottom: theme.spacing(3),
        fontWeight: 700,
        color: theme.palette.iisightWhite,
        textAlign: 'center',
        fontSize: '14px',
        fontStyle: 'normal',
        display: 'flex',
        alignItems: 'center',
    },
}));
const isMobile = isMobileBrowser();
export const ConferenceName = () => {
    const { classes } = useStyles({ isMobile });
    const { t } = useTranslation();
    const conferenceName = useSelector(getConferenceName);
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
            React.createElement("div", { className: classes.nameContainer },
                React.createElement(RecordingLabel, { mode: JitsiRecordingConstants.mode.FILE }),
                React.createElement("h4", { className: classes.text, style: { marginTop: '0px', marginBottom: '0px' } }, conferenceName)))));
};
